import { useEffect, useRef, useState } from "react";
function useFromContentFooter(outOfViewportHeight, fixedMode) {
  const footerRef = useRef(null);
  const footerHeight = footerRef.current?.offsetHeight ?? 0;
  const [footerMode, setFooterMode] = useState(fixedMode ?? "inside-scrollbar");
  const outOfViewportHeightWithoutFooter = footerMode === "inside-scrollbar" ? outOfViewportHeight - footerHeight : outOfViewportHeight;
  const scrollbarVisible = outOfViewportHeightWithoutFooter > 0;
  const scrollbarWillAppear = footerMode === "outside-scrollbar" && !scrollbarVisible && Math.abs(outOfViewportHeight) < footerHeight;
  useEffect(() => {
    if (fixedMode) return;
    const nextFooterMode = scrollbarVisible || scrollbarWillAppear ? "outside-scrollbar" : "inside-scrollbar";
    setFooterMode(nextFooterMode);
  }, [scrollbarVisible, scrollbarWillAppear, fixedMode]);
  return { footerRef, footerMode };
}
export {
  useFromContentFooter
};
//# sourceMappingURL=useFromContentFooter.js.map
